import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"

import {Mutation} from "../"
import {report} from "../../gql/report"

export const mutation = gql`
  mutation CreateReportMutation($params: CreateReportParams!) {
    createReport(params: $params){
      ${report}
    }
  }
`

const QUERIES_TO_REFETCH = ["Reports"]

const CreateReportMutation = ({children, variables, ...props}) => {
  return (
    <Mutation mutation={mutation} {...props}>
      {(mutate, apolloState) => {
        return children((args) => mutate({variables, refetchQueries: QUERIES_TO_REFETCH, awaitRefetchQueries: true, ...args}), apolloState)
      }}
    </Mutation>
  )
}

CreateReportMutation.propTypes = {
  children: PropTypes.func.isRequired,
  variables: PropTypes.shape({
    params: PropTypes.object.isRequired
  }).isRequired
}

CreateReportMutation.defaultProps = {
  variables: {params: {}}
}

export default CreateReportMutation
